// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type ItemResponseShape from '../contract/ItemResponseShape';

export default function itemResponseShape(data: ItemResponseShape): ItemResponseShape {
    const result: ItemResponseShape = {
        __type: 'ItemResponseShape:#Exchange',
        ...data,
    };

    return result;
}
